import React from "react";

export default function FormSubmission({submission}) {

  return (
    <>
      {submission && <div style={{
        display: 'block',
        padding: '15px',
        margin: '8px 0',
        border: 'solid 1px #ddd'
      }}>
        <h5>{submission?.formName}</h5>
        {submission?.submissions?.sort((a, b) => a.sortOrder - b.sortOrder).map((sub, idx) => {
          return (
            <div key={idx}>
              <label style={{
                fontWeight: '500'
              }}>{sub.question}</label>
              <p>
                <small>
                  {sub.questionTypeId === 3 && <>
                  {sub.answer === 'true' && 'Yes'}
                  {sub.answer === 'false' && 'No'}
                  </>}
                  {sub.questionTypeId !== 3 && <>
                    {sub.answer}
                  </>}
                </small>
              </p>
            </div>
          )
        })
        }
      </div>}
    </>
  )
}